import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

// Tags from index.html / the prerender carry data-static-seo; Helmet renders its own copies, so drop the static ones once mounted.
const STATIC_TAGS = "[data-static-seo]";

const DEFAULT_TITLE = "Cyannect — Performance Commerce for North America";
const DEFAULT_DESC = "Cyannect is the performance commerce layer for North America. Discover verified deals, track every click, dollar and conversion. Made for shoppers and brands in Canada and the US.";
const SITE_ORIGIN = typeof window !== "undefined" ? window.location.origin : "https://offer-hub-66.preview.emergentagent.com";

export default function Seo({ title, description, image, path, type = "website", noindex = false, keywords }) {
  const fullTitle = title ? `${title} · Cyannect` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = path ? `${SITE_ORIGIN}${path}` : SITE_ORIGIN;
  const img = image || `${SITE_ORIGIN}/cyannect-logo.png`;
  useEffect(() => { document.querySelectorAll(STATIC_TAGS).forEach((n) => n.remove()); }, []);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content="Cyannect" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_CA" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
